<template>
  <div v-rect-loading="loading" class="job-posting-management-index">
    <TableList
      noHeadBtn
      :titleI18nKey="`${i18nPrefix}.title.index`"
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @edit="handleEdit"
    >
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.jobPosting',
      listData: [],
      tableRowBtns: {
        edit: {
          isShow: (rowData) => !rowData._isChannelHeader
        }
      }
    }
  },
  computed: {
    actionBtn () {
      return {
        edit: {
          show: (rowData) => !rowData._isChannelHeader,
          onclick: this.handleEdit
        }
      }
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.channel`),
          dataKey: 'channel.i18nName',
          formatter: (data, row) => {
            if (row._isChannelHeader) {
              return data
            }
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.fieldType`),
          dataKey: 'i18nName',
          formatter: (data, row) => {
            if (row._isChannelHeader) {
              return null
            }
            return data
          }
        }
      ]
      return columns
    }

  },
  created () {
    this.getListData()
  },
  methods: {
    ...mapActions('jobPosting', ['getPostingFieldList']),
    async getListData () {
      this.loading = true
      try {
        const resp = await this.getPostingFieldList()
        if (resp) {
          let lastChannelId = null
          const listData = []
          _.forEach(resp, item => {
            const channelId = item.channel.id
            addI18nProperty(item, 'i18nName', 'cn_name', 'name')
            if (channelId !== lastChannelId) {
              addI18nProperty(item.channel, 'i18nName', 'cn_name', 'name')
              listData.push({
                ...item,
                _isChannelHeader: true,
                id: `channel_${channelId}`
              })
            }
            listData.push(item)
            lastChannelId = channelId
          })
          this.listData = listData
        }
      } finally {
        this.loading = false
      }
    },
    handleEdit (rowData) {
      const channelId = rowData.channel.id
      const fieldType = rowData.field_type
      this.$router.push(`/v-admin/job-posting-management/${channelId}/${fieldType}/edit`)
    }
  }
}
</script>

<style lang="scss" scoped>
.job-posting-management-index {

}
</style>
